import React from "react";
import "../static/upperBody.css";
import liveImage from "../static/images/live.png";
import groupImage from "../static/images/groupofpeople.png";
import onePersonImage from "../static/images/oneperson.png";
import walletImage from "../static/images/wallet.png";

function UpperBody() {
  return (
    <div className="upperbodyContainer">
      <div className="container-fluid px-0">
        <div className="row">
          <div className="mb-sm-5 mb-5 col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 text-xl-start mx-sm-auto mx-auto  order-xl-1 order-lg-1 order-md-1  order-sm-2 order-2 p-0">
            <div className="row flex-column align-items-center justify-content-center">
              <img className="upperbodyImage" src={liveImage} />
              <div className="curatedHeading font-white artistCuratedHeading text-center col-sm-10  col-10 ">
                Go Live
              </div>
              <div className="curatedDescription artistCuratedDescription text-center col-xl-7 col-lg-7 col-md-7 col-sm-8 col-8 p-0">
                Go live with Ombré. Get a college or corporate gigs
              </div>
            </div>
          </div>

          <div className="mb-sm-5 mb-5 col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 text-xl-start mx-sm-auto mx-auto order-xl-1 order-lg-1 order-md-1  order-sm-2 order-2 p-0">
            <div className="row flex-column align-items-center justify-content-center">
              <img className="upperbodyImage" src={groupImage} />

              <div className="curatedHeading font-white text-center artistCuratedHeading text-center col-xl-12 col-lg-12 col-md-12  col-sm-10  col-10 ">
                Grow your fanbase{" "}
              </div>
              <div className="curatedDescription artistCuratedDescription text-center col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8 p-0">
                Grow your fanbase with the power of live streaming
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="containerFluid">
        <div className="row">
          <div className="mb-sm-5 mb-5 col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 text-xl-start mx-sm-auto mx-auto order-xl-1 order-lg-1 order-md-1  order-sm-2 order-2 p-0">
            <div className="row flex-column align-items-center justify-content-center">
              <img className="upperbodyImage" src={walletImage} />

              <div className="curatedHeading font-white text-center artistCuratedHeading text-center col-xl-12 col-lg-12 col-md-12  col-sm-10  col-10 ">
                Earn Money
              </div>
              <div className="curatedDescription artistCuratedDescription text-center col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8 p-0">
                Monetize your content across your fanbase
              </div>
            </div>
          </div>

          <div className="mb-sm-4 mb-4 col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 text-xl-start mx-sm-auto mx-auto order-xl-1 order-lg-1 order-md-1  order-sm-2 order-2 p-0">
            <div className="row flex-column align-items-center justify-content-center">
              <img className="upperbodyImage" src={onePersonImage} />

              <div className="curatedHeading font-white text-center artistCuratedHeading text-center col-xl-12 col-lg-12 col-md-12  col-sm-12  col-12 ">
                Launch your Portfolio
              </div>
              <div className="curatedDescription artistCuratedDescription text-center col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8 p-0">
                Build your professional artist portfolio in few seconds
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpperBody;



// WEBPACK FOOTER //
// ./src/pages/Artist/components/UpperBody.jsx